<template>
  <div :class="['message-text-container']">
    <span class="text">{{ TUITranslateService.t('AIDesk.并发限制') }}</span>
  </div>
</template>

<script lang="ts">
import { TUITranslateService } from "../../../../../../@aidesk/uikit-engine";
const __sfc_main = {};
__sfc_main.setup = (__props, __ctx) => {
  return {
    TUITranslateService
  };
};
export default __sfc_main;
</script>
<style lang="scss" scoped>
.message-text-container {
  display: inline;
}

.text-select {
  -webkit-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
  user-select: text;
}

.text {
  white-space: pre-wrap;
  font-size: 14px;
  text-size-adjust: none;
  overflow-wrap: break-word;
  word-break: normal;
}

.text:lang(en) {
  white-space: pre-wrap;
  font-size: 14px;
  text-size-adjust: none;
  overflow-wrap: break-word;
  word-break: normal;
}
</style>
